import { useDispatch, useSelector } from "react-redux";

import { notificationsSelector } from "../reducers/ownApp/selectors";
import { removeNotification } from "../reducers/ownApp";
import { useEffect } from "react";
import { useSnackbar } from "notistack";

let displayed = [];

export const Notifier = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(notificationsSelector);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  useEffect(() => {
    notifications.forEach(({ message, options, dismissed = false }) => {
      if (dismissed) {
        closeSnackbar(options.key);
        return;
      }

      if (displayed.includes(options.key)) return;

      enqueueSnackbar(message || "", {
        ...options,
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        onExited: (_, myKey) => {
          dispatch(removeNotification(myKey));
          removeDisplayed(myKey);
        },
      });

      storeDisplayed(options.key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
};
